import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Index extends React.Component {
    render() {
        return (
            <div
                onClick={this.props.handleClick}
                className="flex_full_row margin_bottom_12 padding_borders center barlow_medium_place_holder c_bluish uppercase buttonBorder hand"
            >
                <span>
                    <FormattedMessage id={this.props.id} />
                </span>
                <AddIcon color="primary" className="icon" />
            </div>
        );
    }
}
export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/ButtonAdd.js